/**
 * LocalStorage-обёртка для локального access-токена админки (B-1973, SSO).
 *
 * Личность выдаёт `id.drafter.ru` — токен Драфтера живёт в общей httpOnly-cookie
 * `.drafter.ru`, недоступной JS. Здесь храним только **локальный drafter-access**
 * Акселератора (TTL 15 мин), выданный `exchange-drafter`. С ним ходят все запросы.
 *
 * Истёк access → `lib/api` молча повторяет обмен (браузер сам приложит cookie).
 * Своего токена Драфтера на клиенте не держим.
 */

const ACCESS_KEY = "drafter.admin.access_token";

export const tokenStorage = {
  getAccessToken(): string | null {
    return localStorage.getItem(ACCESS_KEY);
  },

  saveAccessToken(token: string): void {
    localStorage.setItem(ACCESS_KEY, token);
  },

  clear(): void {
    localStorage.removeItem(ACCESS_KEY);
  },
};
